<template>
    <div class="container" style="">
        <div v-if="cargando && !errorMessage" class="qlik-loading-overlay">
            <div class="qlik-spinner"></div>
            <span>Cargando informe...</span>
        </div>
        <div v-if="errorMessage" class="qlik-error-banner">
            <strong>Error cargando el reporte de Qlik:</strong>
            <pre>{{ errorMessage }}</pre>
        </div>
        <qlik-embed
            v-if="appId && sheetId"
            ref="qlikEmbedEl"
            class="classic-app"
            ui="classic/app"
            :app-id="appId"
            :sheet-id="sheetId"
            data-no-toolbar="true"
            opt=notoolbar
            clear-selections="'true'"
            context___json="{interactions:{active: false, select: false, passive: false}}"
        ></qlik-embed>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                qlikHost: "",
                appId: null,
                sheetId: null,
                errorMessage: null,
                reintentandoQlik: false,
                cargando: true,
                qlikTimeoutId: null,
                qlikTimeoutMs: 60000
            }
        },
        methods:{
            obtenerNombreInforme(){
                return this.$route.path.split('/').filter(Boolean).pop();
            },
            async cargarConfiguracionQlik(){
                const nombreInforme = this.obtenerNombreInforme();
                try{
                    const result = await this.$store.getters.api(`qlik-config/${nombreInforme}`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    this.appId = result.data.appId;
                    this.sheetId = result.data.sheetId;
                    return true;
                }catch(error){
                    const response = error && error.response ? error.response : {};
                    const detalle = {
                        mensaje: error.message,
                        status: response.status,
                        data: response.data
                    };
                    console.error("Error obteniendo la configuración de Qlik desde el backend:", detalle);
                    this.errorMessage = `No fue posible obtener la configuración del informe "${nombreInforme}" (${detalle.status || 's/n'}): ${JSON.stringify(detalle.data || detalle.mensaje)}`;
                    return false;
                }
            },
            async getAccessToken(){
                try{
                    let result = await this.$store.getters.api("qlik-auth/token", {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    return result.data.access_token;
                }catch(error){
                    const response = error && error.response ? error.response : {};
                    const detalle = {
                        mensaje: error.message,
                        status: response.status,
                        data: response.data
                    };
                    console.error("Error obteniendo el Token desde el backend:", detalle);
                    this.errorMessage = `No fue posible obtener el token (${detalle.status || 's/n'}): ${JSON.stringify(detalle.data || detalle.mensaje)}`;
                    return null;
                }
            },
            async limpiarSesionQlik(){
                try{
                    await fetch(`https://${this.qlikHost}/logout`, {
                        method: 'GET',
                        mode: 'no-cors',
                        credentials: 'include',
                        redirect: 'follow',
                        cache: 'no-store'
                    });
                }catch(error){
                    console.warn("No se pudo limpiar la sesión previa de Qlik:", error);
                }
            },
            loadQlikScript(){
                return new Promise((resolve, reject) => {
                    var qlik_embed_script = document.createElement('script');
                    qlik_embed_script.setAttribute('crossorigin', 'anonymous');
                    qlik_embed_script.setAttribute('type', 'application/javascript');
                    qlik_embed_script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@qlik/embed-web-components@1/dist/index.min.js');
                    qlik_embed_script.setAttribute('data-host', 'fga.us.qlikcloud.com');
                    qlik_embed_script.setAttribute('data-client-id', 'c8f57be594635f9872cc80f6bdeeb9c8');
                    qlik_embed_script.setAttribute('data-get-access-token', 'getAccessToken');
                    qlik_embed_script.setAttribute('data-auth-type', 'Oauth2');
                    qlik_embed_script.setAttribute('data-access-token-storage', 'session');
                    qlik_embed_script.onload = () => resolve();
                    qlik_embed_script.onerror = () => reject(new Error('No se pudo cargar el script de @qlik/embed-web-components'));
                    document.head.appendChild(qlik_embed_script);
                });
            },
            attachQlikEmbedListeners(){
                const el = this.$refs.qlikEmbedEl;
                if (!el) return;
                el.addEventListener('qlik-embed:error', this.handleQlikError);
                el.addEventListener('qlik-embed:ready', this.handleQlikReady);
            },
            detachQlikEmbedListeners(){
                const el = this.$refs.qlikEmbedEl;
                if (!el) return;
                el.removeEventListener('qlik-embed:error', this.handleQlikError);
                el.removeEventListener('qlik-embed:ready', this.handleQlikReady);
            },
            handleQlikReady(){
                this.reintentandoQlik = false;
                this.cargando = false;
                this.errorMessage = null;
                this.limpiarTimeoutQlik();
            },
            async handleQlikError(event){
                const detail = event && event.detail ? event.detail : event;
                console.error("Error de qlik-embed contra fga.us.qlikcloud.com:", detail);

                if (!this.reintentandoQlik){
                    this.reintentandoQlik = true;
                    console.warn("Error de Qlik, reintentando automáticamente...");
                    await this.reiniciarQlikEmbed();
                    return;
                }

                const innerError = detail && detail.error ? detail.error : {};
                const mensaje = (detail && detail.message) || innerError.message || innerError || JSON.stringify(detail);
                this.errorMessage = mensaje;
                this.cargando = false;
                this.limpiarTimeoutQlik();
            },
            async reiniciarQlikEmbed(){
                this.detachQlikEmbedListeners();
                await this.limpiarSesionQlik();
                const appIdActual = this.appId;
                const sheetIdActual = this.sheetId;
                this.appId = null;
                this.sheetId = null;
                await this.$nextTick();
                this.appId = appIdActual;
                this.sheetId = sheetIdActual;
                await this.$nextTick();
                this.attachQlikEmbedListeners();
            },
            iniciarTimeoutQlik(){
                this.limpiarTimeoutQlik();
                this.qlikTimeoutId = setTimeout(() => {
                    console.error("Qlik no terminó de cargar dentro del tiempo esperado.");
                    this.errorMessage = "El informe de Qlik tardó demasiado en cargar. Intenta recargar la página.";
                    this.cargando = false;
                }, this.qlikTimeoutMs);
            },
            limpiarTimeoutQlik(){
                if (this.qlikTimeoutId){
                    clearTimeout(this.qlikTimeoutId);
                    this.qlikTimeoutId = null;
                }
            }
        },
        async mounted() {
            this.qlikHost = "fga.us.qlikcloud.com";
            window.getAccessToken = this.getAccessToken;

            const configuracionCargada = await this.cargarConfiguracionQlik();
            if (!configuracionCargada) {
                this.cargando = false;
                return;
            }

            try{
                await this.limpiarSesionQlik();
                await this.loadQlikScript();
                await customElements.whenDefined('qlik-embed');
                this.attachQlikEmbedListeners();
                this.iniciarTimeoutQlik();
            }catch(error){
                console.error("Error inicializando Qlik:", error);
                this.errorMessage = error.message;
                this.cargando = false;
            }
        },
        beforeDestroy(){
            this.detachQlikEmbedListeners();
            this.limpiarTimeoutQlik();
        }
    }
</script>

<style>
.container{
  position: relative;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin-top: 40px;
  height: 70vh;
  min-height: 320px;
  width: 100%;
  margin-left: 0;
  padding: 0 5%;
}

.classic-app {
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  border-radius: 3px;
  position: relative;
}

@media screen and (min-width: 576px) {
  .container {
    height: 75vh;
  }
}

@media screen and (min-width: 768px) {
  .container {
    height: 80vh;
    width: 90%;
    margin-left: 5%;
    padding: 0;
  }
}

@media screen and (min-width: 992px) {
  .container {
    height: 85vh;
  }
}

.qlik-error-banner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: #fdecea;
  color: #611a15;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 13px;
}

.qlik-error-banner pre {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 4px 0 0 0;
}

.qlik-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #ffffff;
  color: #6b7280;
  font-size: 14px;
}

.qlik-spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #e5e7eb;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: qlik-spin 0.8s linear infinite;
}

@keyframes qlik-spin {
  to { transform: rotate(360deg); }
}

qlik-embed::part(iframe) {
  pointer-events: none;
}

/* Intentar ocultar la barra dentro del iframe */
iframe {
  width: 100%;
  height: 100%;
}

iframe .qv-panel-sheet-toolbar,
iframe .qv-selection-toolbar,
iframe .qv-toolbar-right {
  display: none !important;
}

</style>

